export var OrientationEnum;
(function (OrientationEnum) {
    OrientationEnum["PORTRAIT"] = "PORTRAIT";
    OrientationEnum["LANDSCAPE"] = "LANDSCAPE";
})(OrientationEnum || (OrientationEnum = {}));
